import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { Button } from "../../../components/ui/button";
import Card from "../../../components/ui/card-snippet";
import { useNavigate } from "react-router-dom";
import { respEnum, NotificationTypeEnum } from "../../../constants/appConstant";
import {
    FormikInput,
    FormikSelect,
    FormikSearchSelect,
    FormikTextArea,
    TagInput
} from "../../../components/formik-components";
import Common from "../../../helper/common";
import '../../../assets/responsive.css';


const formikValidation = yup.object({
    message: yup.string().required("Message is required").max(120, "Message must not exceed 120 characters"),
    title: yup.string().required("Title is required").max(50, "Title must not exceed 50 characters"),
    notificationType: yup.number().required("Type is required"),
    key: yup.string().max(20, "Title must not exceed 20 characters"),
    phoneNumbers: yup.array().min(1, "At least one phone number is required").max(5, "You can only add up to 5 phone numbers"),

});

export default function AddUserNotifications() {
    const navigate = useNavigate();
    const formikRef = useRef();
    const [clubs, setClubs] = useState([]);

    const formInitialValue = {};
    useEffect(() => {
        getClubs();
    }, []);

    const getClubs = async () => {
        return new Promise(async (res) => {
            const response = await Common.ApiService.getInstance().request(
                "GetClubsDDL"
            );
            const data = [
                { id: null, name: "Select Club" },
                ...(response?.data ?? []),
            ];

            setClubs(data);
        });
    };

    const onSubmitData = async (d, action) => {

        debugger
        if (!d.phoneNumbers || d.phoneNumbers.length === 0) {
            Common.showToast("Please add at least one phone number", "Error");
            action.setSubmitting(false);
            return;
        }

        if (+d.notificationType == NotificationTypeEnum.Club_Notification && !d.clubId) {
            Common.showToast("Club Is Required if Notification Type Club Notification", "Error");
            return;
        }

        if (+d.notificationType == NotificationTypeEnum.Club_Notification) {
            d.refId = d.clubId;
        }

        let data = {
            ...d,
            refId: +d.refId,
        };
       
        let response = await Common.ApiService.getInstance().request(
            "SendCustomPushNotification",
            data,
            "POST"
        );
        action.setSubmitting(false);

        if (response) {
            if (response.status == respEnum.Success) {
                Common.SweetAlert.alert(response.message);
                setTimeout(() => {
                    window.location.reload(); 
                }, 1000);
            }
        }
    };

    return (
        <Formik
            initialValues={formInitialValue}
            validationSchema={formikValidation}
            innerRef={formikRef}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={onSubmitData}
        >
            {(formikProps) => {
                formikRef.current = formikProps;
                return (
                    <>
                        <div className="space-y-6 mb-5">
                            <Card title={"Add User Notification"}>
                                <div className="md:grid md:grid-cols-4 gap-4 p-5" >
                                   
                                    <div className="flex flex-col col-span-2 gap-2">
                                        <FormikInput
                                            formikProps={formikProps}
                                            name={"key"}
                                            label={"Key"}
                                            placeholder={"Key"}
                                            maxLength="20"
                                        />

                                    </div>

                                    <div className="flex flex-col col-span-2 gap-2">
                                        <FormikInput
                                            formikProps={formikProps}
                                            name={"title"}
                                            label={"Title"}
                                            placeholder={"Title"}
                                            maxLength="50"
                                        />
                                    </div>


                                    
                                    <div className="flex flex-col col-span-2 gap-2">
                                        <FormikSelect
                                            formikProps={formikProps}
                                            name={"notificationType"}
                                            placeholder={"Notification Type"}
                                            label={"Notification Type"}
                                            data={[
                                                { id: null, name: "Select" },
                                                ...Common.Utility.enumToArray(
                                                    NotificationTypeEnum
                                                ),
                                            ]}
                                        />
                                    </div>

                                    {formikProps.values.notificationType && formikProps.values.notificationType !== NotificationTypeEnum.Club_Notification && (
                                        <div className="flex flex-col col-span-2 gap-2">
                                            <FormikInput
                                                formikProps={formikProps}
                                                name={"refId"}
                                                placeholder={"Enter Reference"}
                                                label={"Reference"}
                                                maxLength="20"
                                            />
                                        </div>
                                    )}

                                    {formikProps.values.notificationType === NotificationTypeEnum.Club_Notification && (
                                        <div className="flex flex-col col-span-2 gap-2">
                                            <FormikSearchSelect
                                                formikProps={formikProps}
                                                name={"clubId"}
                                                data={clubs}
                                                placeholder={"Select Club"}
                                                label={"Club"}
                                            />
                                        </div>
                                    )}
                                </div>
                                    <div className="md:grid md:grid-cols-10 gap-4 p-5" >
                                    <div className="flex flex-col col-span-4 gap-2">
                                        <TagInput
                                            formikProps={formikProps}
                                            name={"phoneNumbers"}
                                            placeholder={"Enter Phone Numbers"}
                                            label={"Phone Numbers"}
                                        />
                                    </div>

                                    <div className="flex flex-col col-span-4 gap-2">
                                        <FormikTextArea
                                            formikProps={formikProps}
                                            name={"message"}
                                            label={"Message"}
                                            placeholder={"Message"}
                                            maxLength="120"
                                        />
                                    </div>
                                </div>
                            </Card>
                        </div>

                        <div className="flex flex-col items-end mt-5">
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    formikProps.handleSubmit();
                                }}
                                disabled={formikProps.isSubmitting}
                                type="submit"
                                className=" btn-sm"
                            >
                                {formikProps.isSubmitting ? "Saving..." : "Save"}
                            </Button>

                        </div>
                    </>
                );
            }}
        </Formik>
    );
}
